
const directoryRoutes = {
  path: "directory",
  children: [
    {
      index: true,
      lazy: async () => {
        const mod = await import("views/Admin/Directory");
        const Directory = mod.default;
        return { Component: Directory };
      },
    },
    {
      path: "visitors",
      lazy: async () => {
        const mod = await import(
          "components/Admin/Presentation/PresentationMetrics/VisitorsLeads"
        );
        const VisitorsLeads = mod.default;
        return { Component: VisitorsLeads };
      },
    },
    {
      path: "leads",
      lazy: async () => {
        const mod = await import("views/Admin/Directory/Leads");
        const Leads = mod.default ;
        return { Component: Leads };
      },
    },
    {
      path: "contact",
      lazy: async () => {
        const mod = await import("views/Admin/Directory");
        const Directory = mod.default;
        return { Component: Directory };
      },
    },
    {
      path: "contact-details",
      lazy: async () => {
        const mod = await import("views/Admin/Directory/Modal/LeadDetails");
        const LeadDetails = mod.default;
        return { Component: LeadDetails };
      },
    },
  ],
};

export default directoryRoutes;
